"use client"

import IconFont from "@repo/ui/iconfont"
import Tooltip from "antd/es/tooltip"
import { useLocale, useTranslations } from "next-intl"

import Style from "./index.module.scss"

export default function LockIcon() {
	const t = useTranslations("PreciousMetalsPage")
	const locale = useLocale()
	return (
		<Tooltip title={t("signInToView")}>
			<IconFont
				type="icon-suo"
				style={{ fontSize: 22 }}
				className={Style.lock}
				onClick={() => {
					window.SmmAuth?.showLogin({
						action: "login",
						language: locale,
						onLoginSuccess: () => {
							window.location.reload()
						},
						onRegisterSuccess: () => {
							window.location.reload()
						},
					})
				}}
			/>
		</Tooltip>
	)
}
